import { call, fork, takeLatest, take } from 'redux-saga/effects';
import { sessionService } from 'redux-react-session';

import { fetchProvider } from '../api';
import { providerActions } from './actions';
import history from '../history'
export function* loadProvider({payload}) {
  const { user } = payload;  
  yield call(fetchProvider, user);
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadProvider() {
  yield takeLatest(providerActions.LOAD_PROVIDER, loadProvider);
}

export function* watchFetchProviderSucces() {
  while (true) {
    const { payload } = yield take(providerActions.FETCH_PROVIDER_SUCCESS);

    window.sessionId = payload.data.sessionId
    sessionService.saveSession({ token: payload.data.sessionId, user: payload.user  })
    .then(() => {
        sessionService.saveUser(payload.data)
    }).catch(err => console.error(err));

  }
}

export function* watchFetchProviderFailed() {
  while (true) {
    const { payload } = yield take(providerActions.FETCH_PROVIDER_FAILED);

    sessionService.deleteSession()
  }
}


//=====================================
//  ROOT
//-------------------------------------

export const providerSagas = [
  fork(watchLoadProvider),
  fork(watchFetchProviderSucces),
  fork(watchFetchProviderFailed),

];
